import {
  SiPython,
  SiR,
  SiHtml5,
  SiCss3,
  SiKotlin,
  SiTypescript,
  SiSwift,
  SiLatex,
  SiReact,
  SiNextdotjs,
  SiVite,
  SiTailwindcss,
  SiBootstrap,
  SiNodedotjs,
  SiExpress,
  SiDjango,
  SiSpringboot,
  SiJsonwebtokens,
  SiJunit5,
  SiPandas,
  SiNumpy,
  SiGithub,
  SiDocker,
  SiLinux,
  SiApple,
  SiSupabase,
  SiNetlify,
  SiVercel,
  SiResend,
  SiPostgresql,
  SiMysql,
  SiAmazonwebservices,
  SiVim,
  SiAndroidstudio,
  SiAndroid,
  SiRstudioide,
  SiClaude,
  SiFigma,
  SiCanva,
  SiRender,
  SiJavascript,
  SiOpenjdk,
  SiC,
  SiCplusplus,
  SiVuedotjs,
  SiEmberdotjs,
  SiKalilinux,
  SiWireshark,
  SiApachehadoop,
  SiHaskell,
  SiScrumalliance,
  SiNextdns,
  SiAnthropic,
  SiExpo,
  SiMapbox,
  SiOpenstreetmap,
  SiPuppeteer,
  SiVitest,
  SiZod,
} from "react-icons/si";
import {
  FiCode,
  FiCpu,
  FiDatabase,
  FiGlobe,
  FiLayers,
  FiLock,
  FiShield,
} from "react-icons/fi";
import { FaNetworkWired, FaWindows } from "react-icons/fa";

function CursorIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      aria-hidden
      {...props}
    >
      <path d="M22.106 5.68L12.5.135a.998.998 0 00-.998 0L1.893 5.68a.84.84 0 00-.419.726v11.186c0 .3.16.577.42.727l9.607 5.547a.999.999 0 00.998 0l9.608-5.547a.84.84 0 00.42-.727V6.407a.84.84 0 00-.42-.726zm-.603 1.176L12.228 22.92c-.063.108-.228.064-.228-.061V12.34a.59.59 0 00-.295-.51l-9.11-5.26c-.107-.062-.063-.228.062-.228h18.55c.264 0 .428.286.296.514z" />
    </svg>
  );
}

export const skillIconMap = {
  react: SiReact,
  typescript: SiTypescript,
  next: SiNextdotjs,
  vite: SiVite,
  html: SiHtml5,
  css: SiCss3,
  tailwindcss: SiTailwindcss,
  bootstrap: SiBootstrap,
  javascript: SiJavascript,
  vue: SiVuedotjs,
  ember: SiEmberdotjs,
  javafx: SiOpenjdk,
  node: SiNodedotjs,
  express: SiExpress,
  restapidevelopment: FiGlobe,
  postgresql: SiPostgresql,
  mysql: SiMysql,
  supabase: SiSupabase,
  django: SiDjango,
  springboot: SiSpringboot,
  java: SiOpenjdk,
  c: SiC,
  cplusplus: SiCplusplus,
  jwt: SiJsonwebtokens,
  bcrypt: FiLock,
  resend: SiResend,
  netlify: SiNetlify,
  vercel: SiVercel,
  render: SiRender,
  aws: SiAmazonwebservices,
  kali: SiKalilinux,
  wireshark: SiWireshark,
  cryptography: FiLock,
  networksecurity: FiShield,
  dns: SiNextdns,
  kotlin: SiKotlin,
  androidstudio: SiAndroidstudio,
  jetpackcompose: SiAndroid,
  junit: SiJunit5,
  swift: SiSwift,
  python: SiPython,
  pandas: SiPandas,
  numpy: SiNumpy,
  r: SiR,
  rstudio: SiRstudioide,
  sql: FiDatabase,
  algorithms: FiCpu,
  datastructures: FiLayers,
  hpc: FiCpu,
  mapreduce: SiApachehadoop,
  haskell: SiHaskell,
  gitgithub: SiGithub,
  docker: SiDocker,
  linuxunix: SiLinux,
  macos: SiApple,
  windows: FaWindows,
  vim: SiVim,
  cursor: CursorIcon,
  claude: SiClaude,
  figma: SiFigma,
  canva: SiCanva,
  latex: SiLatex,
  agile: SiScrumalliance,
  concurrency: FaNetworkWired,
  assembly: FiCode,
  verilog: FiCpu,
  computability: FiLayers,
  zod: SiZod,
  anthropicapi: SiAnthropic,
  mapbox: SiMapbox,
  expo: SiExpo,
  vitest: SiVitest,
  puppeteer: SiPuppeteer,
  openstreetmap: SiOpenstreetmap,
};

export const skillToneByKey = {
  react: { bg: "rgba(97, 218, 251, 0.28)", color: "#2a8fad" },
  typescript: { bg: "rgba(49, 120, 198, 0.24)", color: "#3178c6" },
  next: { bg: "rgba(24, 27, 33, 0.08)", color: "#181b21" },
  vite: { bg: "rgba(100, 108, 255, 0.24)", color: "#646cff" },
  html: { bg: "rgba(227, 79, 38, 0.22)", color: "#e34f26" },
  css: { bg: "rgba(21, 114, 182, 0.22)", color: "#1572b6" },
  tailwindcss: { bg: "rgba(6, 182, 212, 0.24)", color: "#0ea5b7" },
  bootstrap: { bg: "rgba(121, 82, 179, 0.22)", color: "#7952b3" },
  javascript: { bg: "rgba(247, 223, 30, 0.28)", color: "#b8a000" },
  vue: { bg: "rgba(66, 184, 131, 0.24)", color: "#42b883" },
  ember: { bg: "rgba(231, 75, 54, 0.22)", color: "#e74b36" },
  javafx: { bg: "rgba(0, 115, 150, 0.22)", color: "#007396" },
  node: { bg: "rgba(51, 153, 51, 0.24)", color: "#339933" },
  express: { bg: "rgba(24, 27, 33, 0.08)", color: "#2a3548" },
  restapidevelopment: { bg: "rgba(79, 157, 130, 0.24)", color: "#3d8a6e" },
  postgresql: { bg: "rgba(51, 103, 145, 0.24)", color: "#336791" },
  mysql: { bg: "rgba(0, 117, 143, 0.22)", color: "#00758f" },
  supabase: { bg: "rgba(62, 207, 142, 0.24)", color: "#3ecf8e" },
  django: { bg: "rgba(9, 46, 32, 0.14)", color: "#092e20" },
  springboot: { bg: "rgba(109, 179, 63, 0.24)", color: "#6db33f" },
  java: { bg: "rgba(0, 115, 150, 0.22)", color: "#007396" },
  c: { bg: "rgba(90, 147, 204, 0.24)", color: "#5a93cc" },
  cplusplus: { bg: "rgba(0, 89, 156, 0.22)", color: "#00599c" },
  jwt: { bg: "rgba(0, 0, 0, 0.08)", color: "#2a3548" },
  bcrypt: { bg: "rgba(196, 146, 58, 0.24)", color: "#9a742e" },
  resend: { bg: "rgba(24, 27, 33, 0.08)", color: "#181b21" },
  netlify: { bg: "rgba(0, 200, 167, 0.24)", color: "#00c8a7" },
  vercel: { bg: "rgba(24, 27, 33, 0.08)", color: "#181b21" },
  render: { bg: "rgba(70, 203, 174, 0.24)", color: "#46cbae" },
  aws: { bg: "rgba(255, 153, 0, 0.24)", color: "#d97706" },
  kali: { bg: "rgba(38, 117, 194, 0.22)", color: "#2675c2" },
  wireshark: { bg: "rgba(22, 119, 184, 0.22)", color: "#1677b8" },
  cryptography: { bg: "rgba(90, 70, 140, 0.2)", color: "#5a468c" },
  networksecurity: { bg: "rgba(180, 60, 60, 0.18)", color: "#a33c3c" },
  dns: { bg: "rgba(0, 122, 204, 0.2)", color: "#007acc" },
  kotlin: { bg: "rgba(127, 82, 255, 0.22)", color: "#7f52ff" },
  androidstudio: { bg: "rgba(61, 220, 132, 0.24)", color: "#3ddc84" },
  jetpackcompose: { bg: "rgba(61, 220, 132, 0.24)", color: "#3ddc84" },
  junit: { bg: "rgba(37, 90, 42, 0.18)", color: "#255a2a" },
  swift: { bg: "rgba(240, 81, 56, 0.22)", color: "#f05138" },
  python: { bg: "rgba(55, 118, 171, 0.24)", color: "#3776ab" },
  pandas: { bg: "rgba(19, 15, 64, 0.12)", color: "#130f40" },
  numpy: { bg: "rgba(77, 119, 173, 0.24)", color: "#4d77ad" },
  r: { bg: "rgba(39, 109, 195, 0.22)", color: "#276dc3" },
  rstudio: { bg: "rgba(117, 189, 66, 0.24)", color: "#75bd42" },
  sql: { bg: "rgba(51, 103, 145, 0.22)", color: "#336791" },
  algorithms: { bg: "rgba(79, 157, 130, 0.22)", color: "#3d8a6e" },
  datastructures: { bg: "rgba(70, 110, 160, 0.2)", color: "#466ea0" },
  hpc: { bg: "rgba(40, 90, 140, 0.2)", color: "#285a8c" },
  mapreduce: { bg: "rgba(255, 163, 0, 0.22)", color: "#d97706" },
  haskell: { bg: "rgba(94, 80, 134, 0.22)", color: "#5e5086" },
  gitgithub: { bg: "rgba(24, 27, 33, 0.08)", color: "#181b21" },
  docker: { bg: "rgba(36, 150, 237, 0.24)", color: "#2496ed" },
  linuxunix: { bg: "rgba(24, 27, 33, 0.08)", color: "#181b21" },
  macos: { bg: "rgba(24, 27, 33, 0.08)", color: "#2a3548" },
  windows: { bg: "rgba(0, 120, 215, 0.22)", color: "#0078d7" },
  vim: { bg: "rgba(1, 144, 54, 0.22)", color: "#019036" },
  cursor: { bg: "rgba(79, 157, 130, 0.24)", color: "#3d8a6e" },
  claude: { bg: "rgba(217, 119, 87, 0.24)", color: "#d97757" },
  figma: { bg: "rgba(162, 89, 255, 0.18)", color: "#a259ff" },
  canva: { bg: "rgba(0, 196, 204, 0.24)", color: "#00c4cc" },
  latex: { bg: "rgba(0, 128, 128, 0.18)", color: "#008080" },
  agile: { bg: "rgba(0, 153, 168, 0.22)", color: "#0099a8" },
  concurrency: { bg: "rgba(90, 120, 160, 0.2)", color: "#5a78a0" },
  assembly: { bg: "rgba(80, 80, 90, 0.16)", color: "#50505a" },
  verilog: { bg: "rgba(0, 100, 120, 0.18)", color: "#006478" },
  computability: { bg: "rgba(100, 80, 140, 0.18)", color: "#64508c" },
  zod: { bg: "rgba(62, 103, 177, 0.22)", color: "#3e67b1" },
  anthropicapi: { bg: "rgba(217, 119, 87, 0.24)", color: "#d97757" },
  mapbox: { bg: "rgba(66, 100, 251, 0.2)", color: "#4264fb" },
  expo: { bg: "rgba(0, 0, 32, 0.08)", color: "#181b21" },
  vitest: { bg: "rgba(114, 155, 27, 0.22)", color: "#5f8a12" },
  puppeteer: { bg: "rgba(64, 181, 164, 0.24)", color: "#2f9a8a" },
  openstreetmap: { bg: "rgba(126, 188, 111, 0.24)", color: "#5a9a4a" },
};

export const defaultSkillTone = {
  bg: "rgba(27, 38, 59, 0.07)",
  color: "#2a3548",
};

export function getSkillIcon(id) {
  return skillIconMap[id] || FiCode;
}

export function getSkillTone(id) {
  return skillToneByKey[id] || defaultSkillTone;
}
